import { render, staticRenderFns } from "./MensageriaSendPanel.vue?vue&type=template&id=55a24e1a&scoped=true"
import script from "./MensageriaSendPanel.vue?vue&type=script&lang=js"
export * from "./MensageriaSendPanel.vue?vue&type=script&lang=js"
import style0 from "./MensageriaSendPanel.vue?vue&type=style&index=0&id=55a24e1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a24e1a",
  null
  
)

export default component.exports